import React, { useRef, useEffect } from "react";
import { animate, useMotionValue, useTransform } from "framer-motion";

const NumberTicker = ({ value, trigger = true }) => {
  const match = value ? String(value).match(/(\d+)(.*)/) : null;
  const targetNumber = match ? parseInt(match[1]) : 0;
  const suffix = match ? match[2] : "";

  const count = useMotionValue(0);
  const rounded = useTransform(count, (latest) => Math.round(latest));
  const nodeRef = useRef(null);

  useEffect(() => {
    if (trigger) {
      count.set(0); // Reset the count back to 0 before animating
      const controls = animate(count, targetNumber, {
        duration: 2,
        ease: "easeOut",
      });
      return controls.stop;
    }
  }, [trigger, targetNumber, count]);

  useEffect(() => {
    return rounded.on("change", (latest) => {
      if (nodeRef.current) {
        nodeRef.current.textContent = latest;
      }
    });
  }, [rounded]);

  return (
    <span>
      <span ref={nodeRef}>0</span>
      {suffix}
    </span>
  );
};

export default NumberTicker;
